module.exports = __webpack_public_path__ + "img/technology-14.964316d9.png";